export default [
    {
        name: 'Dana Wharf Sportfishing &amp; Whale Watching',
        logo: 'DW–corp_logo_no_boat.png',
        url: 'http://www.danawharf.com/'
    },
    {
        name: 'Rosodigital Creative Solutions',
        logo: 'rsd-logo-small-1.png',
        url: 'http://rosodigital.com/'
    },
    {
        name: 'San Clemente Internal Medical Group',
        logo: 'scmg-1.png',
        url: 'http://www.scimg.net/'
    },
    {
        name: 'The Ritz Carlton',
        logo: 'TRC-Assym-Reverse.png',
        url: 'http://www.ritzcarlton.com/'
    },
    {
        name: 'Catalina Express',
        logo: 'catalina-express-logo.png',
        url: 'http://www.catalinaexpress.com/'
    },
    {
        name: 'The Retreat in Laguna',
        logo: 'The_Retreat_in_Laguna_Logo_D.jpg',
        url: 'http://www.theretreatinlaguna.com/'
    },
    {
        name: 'Surf and Sand Resort',
        logo: 'ssr-footer-logo.png',
        url: 'http://www.surfandsandresort.com/'
    },
    {
        name: 'Wyland',
        logo: 'wyland-logo.png',
        url: 'http://www.wyland.com/'
    },
    {
        name: 'Rainbow Sandals',
        logo: 'rainbow-sandals-logo.png',
        url: 'http://www.rainbowsandals.com/'
    },
    {
        name: 'Allen Family Foundation',
        logo: '',
        url: ''
    },
    {
        name: 'Microsemi',
        logo: 'microsemi-logo.png',
        url: 'http://www.microsemi.com/'
    },
    {
        name: 'E-Junkie',
        logo: 'logo.svg',
        url: 'http://www.e-junkie.com/'
    },
    {
        name: 'SoCal Edison | S.O.N.G.S.',
        logo: 'SCE-SONGS-Logo-1.png',
        url: 'http://www.songscommunity.com/'
    },
    {
        name: 'Millennium Systems',
        logo: 'nextmill-1.png',
        url: 'http://nextmill.net/'
    },
    {
        name: 'Reiman Foundation, Inc',
        logo: 'reiman-foundation-logo.png',
        url: 'http://www.reimanfoundation.org/'
    },
    {
        name: 'Laguna Beach Community Foundation',
        logo: 'laguna-beach-community-foundation-logo.png',
        url: 'http://www.lagunabeachcf.org/'
    },
    {
        name: 'CA Coastal Commission',
        logo: 'ca-coastal-commission-logo.png',
        url: 'http://www.coastal.ca.gov/'
    },
    {
        name: 'NOAA',
        logo: 'noaa_white-1.gif',
        url: 'http://www.noaa.gov/'
    },
    {
        name: 'OC Community Foundation',
        logo: 'orange-county-community-foundation-logo.png',
        url: 'http://www.oc-cf.org/'
    }
]